/* eslint-disable no-restricted-syntax */
import clone from 'lodash/clone';
import each from 'lodash/each';
import setWith from 'lodash/setWith';

export const toFormData = <T extends {}>(data: T, formData = new FormData(), namespace = '') => {
    if (data instanceof Blob) {
        formData.append(namespace, data);
    } else if (data instanceof Array) {
        // work around for model binding issue in .NET
        // should not need special array handling in .NET Core 3
        // https://github.com/aspnet/AspNetCore/issues/4802#issuecomment-449628162
        const arr: Array<any> = data as any; // eslint-disable-line @typescript-eslint/no-explicit-any
        arr.forEach((element, index) => {
            formData.append(`${namespace}.Index`, index.toString());
            const tempFormKey = `${namespace}[${index}]`;
            const e = element == null ? null : element;
            toFormData(e, formData, tempFormKey);
        });
    } else if (typeof data === 'object') {
        each(data as {}, (value, key) => {
            if (value != null) {
                const formKey = namespace ? `${namespace}[${key}]` : key.toString();
                toFormData(value, formData, formKey);
            }
        });
    } else {
        formData.append(namespace, data.toString());
    }
    return formData;
};

export const toFormDataAppeasment = <T extends {}>(data: T, formData = new FormData(), namespace = '') => {
    if (data instanceof Blob) {
        formData.append(namespace, data);
    } else if (typeof data === 'object') {
        each(data as {}, (value, key) => {
            if (value != null) {
                const formKey = namespace ? `${namespace}[${key}]` : key.toString();
                toFormDataAppeasment(value, formData, formKey);
            }
        });
    } else {
        formData.append(namespace, data.toString());
    }
    return formData;
};

export const isShallowEqual = (o1: Object, o2: Object) => {
    for (const key in o1) {
        if (!(key in o2) || o1[key] !== o2[key]) {
            return false;
        }
    }

    for (const key in o2) {
        if (!(key in o1) || o1[key] !== o2[key]) {
            return false;
        }
    }

    return true;
};

// source - https://coderwall.com/p/urxpsa/remove-falsy-values-or-empty-strings-from-javascript-objects
/**
 * removeFalsy
 *  returns object without falsy values (null, undefined, empty string)
 * @param obj - Object
 */
export const removeFalsy = (obj: Object) => {
    const newObj = {};
    Object.keys(obj).forEach((prop) => {
        if (obj[prop]) {
            newObj[prop] = obj[prop];
        }
    });
    return newObj;
};

export const setIn = <T extends Object, U>(obj: T, path: string | Array<string | number>, value: U): T => {
    if (!path.length) {
        return value as any; // eslint-disable-line @typescript-eslint/no-explicit-any
    }
    return setWith(clone(obj), path, value, clone);
};
